<template>
    <el-tree ref="_tree" :data="data" :empty-text="emptyText" :node-key="nodeKey" :props="nodeProps"
        :render-after-expand="renderAfterExpand" :highlight-current="highlightCurrent"
        :default-expand-all="defaultExpandAll" :expand-on-click-node="expandOnClickNode"
        :check-on-click-node="checkOnClickNode" :auto-expand-parent="autoExpandParent"
        :default-expanded-keys="defaultExpandedKeys" :show-checkbox="showCheckbox" :check-strictly="checkStrictly"
        :default-checked-keys="defaultCheckedKeys" :current-node-key="currentNodeKey"
        :filter-node-method="filterNodeMethod" :accordion="accordion" :indent="indent" @node-click="onNodeClick"
        @current-change="onCurrentChange">
        <template #default="slotProps">
            <slot v-bind="slotProps"></slot>
        </template>
    </el-tree>
</template>

<script setup lang="ts">
import { computed, useTemplateRef } from 'vue';
import { ElTree } from 'element-plus'
import { TreeExpose, TreeNode, TreeNodeData, TreeProps } from './Tree'

defineOptions({
    name: 'OTree',
    inheritAttrs: false
})

const { data,
    emptyText,
    nodeKey,
    nodeLabel,
    nodeChildren,
    nodeDisabled,
    nodeClass,
    renderAfterExpand = true,
    highlightCurrent,
    defaultExpandAll,
    expandOnClickNode = true,
    checkOnClickNode,
    autoExpandParent = true,
    defaultExpandedKeys,
    showCheckbox,
    checkStrictly,
    defaultCheckedKeys,
    currentNodeKey,
    filterNodeMethod,
    accordion,
    indent } = defineProps<TreeProps>()

const nodeProps = computed(() => {
    return {
        label: nodeLabel,
        children: nodeChildren,
        disabled: nodeDisabled,
        class: nodeClass
    }
})

const treeInst = useTemplateRef('_tree')
const filter: TreeExpose['filter'] = (value) => {
    treeInst.value!.filter(value)
}
const getCheckedKeys: TreeExpose['getCheckedKeys'] = (leafOnly) => {
    return treeInst.value!.getCheckedKeys(leafOnly)
}
const setCheckedKeys: TreeExpose['setCheckedKeys'] = (keys) => {
    treeInst.value!.setCheckedKeys(keys)
}
const getCurrentKey: TreeExpose['getCurrentKey'] = () => {
    return treeInst.value!.getCurrentKey()
}
const setCurrentKey: TreeExpose['setCurrentKey'] = (key, shouldAutoExpandParent) => {
    treeInst.value!.setCurrentKey(key, shouldAutoExpandParent)
}

defineExpose({
    filter,
    getCheckedKeys,
    setCheckedKeys,
    getCurrentKey,
    setCurrentKey
})

const emit = defineEmits(['node-click', 'current-change'])
const onNodeClick = (nodeData: TreeNodeData, node: TreeNode, instance: any, e: MouseEvent) => {
    emit('node-click', nodeData, node, instance, e)
}
const onCurrentChange = (nodeData: TreeNodeData, node: TreeNode) => {
    emit('current-change', nodeData, node)
}
</script>